const sectionMapping = (data) => {
  return data.map((item) => ({
    name: item.name,
    center_section_to_field: item.center_section_to_field ? true : false,
    default_location: {
      x: Number(item.offsetX),
      y: Number(item.offsetY),
      z: 0,
    },
    default_size: {
      width: Number(item.width),
      height: Number(item.height),
    },
    pricing: {
      price_model: item.price_model,
      price: Number(item.price),
    },
    artwork_angle: Number(item.sectionAngle),
    radial_angle: Number(item.radialAngle),
    maintain_aspect_ratio: item.maintain_aspect_ratio ? true : false,
    preview_mark_speed: Number(item.preview_mark_speed),
    marking_order: item.marking_order,
    keystone_correction: {
      horizontal_ratio_percentage: Number(item.horizontal_ratio_percentage),
      vertical_ratio_percentage: Number(item.vertical_ratio_percentage),
    },
    preview_mark_type: item.preview_mark_type,
    outline_laser_profile_id: item.outline_laser_profile_id,
    hatch_profile_ids: item.hatch_profile_ids,
    thumbnail_image_url: item.thumbnail_image_url,
    getImg: item.image,
  }))
}
export default sectionMapping
